// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"754":"3515c5d3","787":"ecc8cfa9"}[chunkId] + ".chunk.js";
};